import React from 'react';

import SystemContext from "./SystemContext";
import {headerLogoNorthumberland, passportNorthumberlandMenu} from "@ehcp/SystemConstants";

const SystemProvider = ({dataset, children}) => {

    return (
        <SystemContext.Provider
            value={{
                headerLogoDetails: headerLogoNorthumberland,
                menuDescriptor: passportNorthumberlandMenu
            }}
        >
        {children}
        </SystemContext.Provider>
    )
}

export default SystemProvider;
